module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messageSent":"Message sent"}}')
  delete Component.options._Ctor
}
